import { Box, makeStyles } from "@material-ui/core"
import React from "react"
import { Trans } from "@lingui/macro"
import { RowBox } from "../Boxes/RowBox"
import { Icon } from "../Icon/Icon"

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "16px",
    color: theme.palette.grey[400]
  }
}))

const AdminOnlyLabel = ({ label = <Trans>Managers only</Trans> }) => {
  const classes = useStyles()

  return (
    <RowBox className={classes.root}>
      <Icon name="view-alt" />
      <Box ml={1}>{label}</Box>
    </RowBox>
  )
}

export { AdminOnlyLabel }
